<template>
  <layout-panel :class="['question-panel', indexe.isJumped?'jump':'']"
                :collapse="!showBody">
    <!-- 面板标题 -->
    <template slot="header">
      <span @click="console(question)">
        Q{{questionIndex+1}} {{types[question.type]}}<span v-show="indexe.isJumped">(已跳过)</span>
      </span>
    </template>
    <template slot="tools"></template>
    <!-- 题目标题 -->
    <div class="question-title">
      <span class="question-title-text">{{question.title}}</span>
    </div>
    <!-- 题目信息 -->
    <question-detail
      :question="question"
      :question-index="questionIndex"
      :show-example="false"/>
    <!-- 题目选项 -->
    <question-option
      v-if="question.options"
      :question="question"
      :question-index="questionIndex"
      :answer="answer"
      :disabled="disabled"/>
    <!-- 题目文本答案 -->
    <template v-if="answer.hasOwnProperty('text')">
      <div class="answer-title">
        文本答案
      </div>
      <answer-text
        :answer="answer"
        :disabled="disabled"/>
    </template>
  </layout-panel>
</template>

<script>
import QuestionReview from '@views/question-review/question-review.js'
import QuestionDetail from '@views/question-review/packages/QuestionDetail'
import QuestionOption from '@views/question-review/packages/QuestionOption'
import AnswerText from '@views/question-review/packages/AnswerText'
import AnswerFileList from '@views/question-review/packages/AnswerFileList'
import QuestionReviewButton from '@views/question-review/packages/QuestionReviewButton'
import QuestionComment from '@views/question-review/packages/QuestionComment'

export default {
  components: {QuestionDetail, QuestionOption, AnswerText, AnswerFileList, QuestionReviewButton, QuestionComment},
  mixins: [],
  props: {
    question: Object,
    questionIndex: Number,
    answer: Object,
  },
  data () {
    return {
      showBody: true,
      indexe: QuestionReview().getQuestion(this.question.id),
      types: {
        info: '文字题',
        text: '填空题',
        multitext: '多项填空题',
        select: '单选题',
        multiselect: '多选题',
        imageMultiselect: '图片多选题',
      },
      evidenceTypes: {
        photo: '照片',
        video: '视频',
        record: '录音',
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      orderDetail: state => state.tekeQuestionReview.orderDetail,
      questionContainerElement: state => state.orderReview.questionContainerElement,
    }),
    ...Vuex.mapGetters('orderReview', [
      'allowModifyAnswer',
      'allowOrderReview',
    ]),
    isJumped () {
      return this.indexe.isJumped
    },
    disabled () {
      return this.isJumped || !this.allowModifyAnswer
    },
    refer () {
      let indexe = QuestionReview().getReferQuestion(this.question.id)[0]
      if (indexe) {
        return {
          index: indexe.index(),
          question: indexe.data,
          answer: indexe.answer,
        }
      }
      return false
    },
  },
  watch: {
    isJumped (val) {
      this.showBody = !val
    },
  },
  beforeCreate () {},
  created () {
    // 跳过的题目默认收起
    if (this.isJumped) {
      this.showBody = false
    }
    this.$nextTick(() => {
      QuestionReview().setQuestionElement(this.question.id, this.$el)
    })
  },
  mounted () {},
  methods: {
    ...Vuex.mapActions([]),
    console (json) {
      console.log('question', json)
      console.log('questions', QuestionReview().questions)
      console.log('answer', QuestionReview().getAnswers())
      // WARNING: 此模块已经没了
      console.log('submit-answer', QuestionReview().getRecoveryAnswers())
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/teke-order-review/pages/TekeOrderReviewQuestion.vue